// extracted by mini-css-extract-plugin
export default {"header":"ViewProgramAssistant_header__RLogN","redirectButton":"ViewProgramAssistant_redirectButton__wbWkK"};